import  request from './request.js'


// 查询地址接口
export function Login(data) {

  return request({
    url: "",
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    method: 'post',
    data

  });
}



// WEBPACK FOOTER //
// ./src/api/http.js